<div [ngSwitch]="state">
    <app-token-validation *ngSwitchCase="SelfEnrollmentState.TokenValidation" [token]="externalToken" (signal)="signal($event)"></app-token-validation>
    <app-token-invalid *ngSwitchCase="SelfEnrollmentState.TokenInvalid"></app-token-invalid>
    <app-token-expired
        *ngSwitchCase="SelfEnrollmentState.TokenExpired"
        (signal)="signal($event)"
        [token]="externalToken"
        [dealerCode]="sharedData.oemDealerId"
    ></app-token-expired>
    <app-token-verification
        *ngSwitchCase="SelfEnrollmentState.TokenVerification"
        [token]="externalToken"
        [oemCode]="sharedData.oemCode"
        [jacketId]="sharedData.jacketId"
        (signal)="signal($event)"
    ></app-token-verification>
    <app-initial-dealer-setup
        *ngSwitchCase="SelfEnrollmentState.DealerSetupInitial"
        [dealerId]="sharedData.dealerId"
        [dealerName]="sharedData.dealerName"
        [dealerCode]="sharedData.oemDealerId"
        (signal)="signal($event)"
        [token]="externalToken"
        [jacketId]="sharedData.jacketId"
    ></app-initial-dealer-setup>
    <app-initial-user-password
        *ngSwitchCase="SelfEnrollmentState.DealerSetupSetUserPassword"
        (signal)="signal($event)"
        [token]="externalToken"
        [jacketId]="sharedData.jacketId"
        [needsNewPassword]="sharedData.needsNewPassword"
        [user]="sharedData.currentUser"
        [dealerId]="sharedData.dealerId"
        [dealerName]="sharedData.dealerName"
        [dealerCode]="sharedData.oemDealerId"
        [checkedSystemDocuments]="sharedData.checkedSystemDocuments"
        [email]="sharedData.email"
        [firstName]="sharedData.firstName"
        [lastName]="sharedData.lastName"
        [phone]="sharedData.phone"
        [jobTItle]="sharedData.jobTitle"
        [carryoverPassword]="sharedData.password"
    ></app-initial-user-password>
    <app-additional-admins
        *ngSwitchCase="SelfEnrollmentState.DealerSetupAdditionalAdmins"
        [dealerName]="sharedData.dealerName"
        [dealerCode]="sharedData.oemDealerId"
        [currentUser]="sharedData.currentUser"
        [dealerId]="sharedData.dealerId"
        (signal)="signal($event)"
        [token]="externalToken"
    ></app-additional-admins>
    <ng-container *ngSwitchCase="SelfEnrollmentState.MfaVerification">
        <enter-verification (verify$)="verifyChange($event)" [phone]="user.phone"></enter-verification>
    </ng-container>
</div>
